import React, { useState } from 'react';
import { X } from 'lucide-react';

const IframeModal = ({ isOpen, onClose, url, title }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/80 p-4">
      <div className="relative w-full max-w-6xl h-[90vh] bg-white rounded-lg shadow-2xl overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between bg-gradient-to-r from-orange-500 to-orange-600 text-white px-6 py-4">
          <h3 className="text-xl font-bold">{title || 'Pembelian Tiket'}</h3>
          <button
            onClick={onClose}
            className="text-white hover:bg-white/10 p-2 rounded-full transition-colors"
          >
            <X size={24} />
          </button>
        </div>

        {/* Iframe Content */}
        <div className="w-full h-[calc(100%-64px)]">
          <iframe
            src={url}
            className="w-full h-full border-0"
            title={title || 'External Content'}
            sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox"
          />
        </div>
      </div>
    </div>
  );
};

export default IframeModal;
